// Display-only clean-ups on a COPY of a quotation; mirrors backend/utils/display_clean.py.

const categoryNames = (q) => {
  const qli = q?.quote_line_items || {};
  const names = new Set(q?.selected_categories || []);
  Object.keys(qli.category_pricing || {}).forEach((k) => names.add(k));
  Object.values(qli.meal_plan_pricing || {}).forEach((mp) =>
    Object.keys(mp?.category_pricing || {}).forEach((k) => names.add(k))
  );
  return new Set([...names].filter((n) => typeof n === 'string' && n !== n.trim()));
};

const strip = (o, names) => {
  if (Array.isArray(o)) return o.map((v) => strip(v, names));
  if (o && typeof o === 'object') {
    return Object.fromEntries(
      Object.entries(o).map(([k, v]) => [names.has(k) ? k.trim() : k, strip(v, names)])
    );
  }
  return typeof o === 'string' && names.has(o) ? o.trim() : o;
};

// 'Premium ' -> 'Premium' in every key and value, so lookups stay consistent.
export const trimCategoryNames = (quotation) => {
  if (!quotation || typeof quotation !== 'object') return quotation;
  const names = categoryNames(quotation);
  return names.size ? strip(quotation, names) : quotation;
};

// Country code only when there is a phone number (never a lone '+91').
export const guestPhoneDisplay = (q) => {
  const phone = String(q?.guest_phone || '').trim();
  if (!phone) return '';
  return phone.startsWith('+') ? phone : `${q?.guest_country_code || '+91'} ${phone}`;
};
